// User-facing Italian labels for the Ancillari Auto wizard fields that can
// block "Continua". Mirrors src/screens/RcVehicle.stepErrors.js, trimmed to the
// fields this funnel actually has (no driver/owner sub-forms, no merit class,
// no insurance_type).
export const STEP_FIELD_LABELS = {
  // Step 1 — Dati del Veicolo
  vehicle_plate: 'Targa',
  is_old_plate: 'Tipo di Targa',
  imm_vehicle_month: 'Mese di immatricolazione',
  imm_vehicle_year: 'Anno di immatricolazione',
  vehicle_brand_code: 'Marca',
  vehicle_model_code: 'Modello',
  vehicle_version_code: 'Versione',
  other_power_supply: 'Altra alimentazione',
  vehicle_parking: 'Parcheggio auto',
  theft_protection_code: 'Antifurto',
  vehicle_usage: 'Utilizzo',
  predicted_km: 'Km percorsi in un anno',
  vehicle_purchased_month: 'Mese di acquisto del veicolo',
  vehicle_purchased_year: 'Anno di acquisto del veicolo',
  vehicle_value: 'Valore del veicolo',
  vehicles_owned: 'Auto nel nucleo familiare',
  tow_hook: 'Gancio di traino',
  weight: 'Peso',
  power: 'Potenza',

  // Step 2 — Garanzie
  guarantees: 'Garanzie',

  // Step 3 — Dati Personali
  gender: 'Il contraente è',
  name: 'Nome',
  surname: 'Cognome',
  business_name: 'Ragione sociale',
  vat_number: 'Partita IVA',
  company_type: 'Tipologia azienda',
  date_of_birth: 'Data di nascita',
  commune_of_birth_code: 'Comune di nascita',
  province_of_birth_code: 'Provincia di nascita',
  born_abroad: "Nato all'estero",
  country_of_birth_code: 'Stato estero di nascita',
  residence_commune_code: 'Comune di residenza',
  residence_province_code: 'Provincia di residenza',
  postal_code: 'CAP',
  address: 'Indirizzo',
  house_number: 'Numero civico',
  email: 'Email',
  phone: 'Telefono',
  policy_effective_date: 'Data di decorrenza polizza',
  payment_frequency: 'Frequenza di pagamento',
};

// Fields that live inside each step's collapsed "Detagli" panel, keyed by step
// index. Only step 1 has a panel in this funnel.
export const COLLAPSED_PANEL_FIELDS_BY_STEP = {
  1: ['weight', 'power', 'other_power_supply', 'vehicle_parking', 'theft_protection_code', 'vehicle_usage', 'predicted_km', 'vehicles_owned'],
};

export const getBlockingFields = (errors, stepFields) => (stepFields || []).filter((field) => errors && errors[field]);

// Keep the list short enough to stay readable inside a toast.
export const buildMissingFieldsMessage = (fields, labels = STEP_FIELD_LABELS, max = 3) => {
  const names = (fields || []).map((field) => labels[field] || field);
  if (names.length > max) {
    return `Compila i campi obbligatori: ${names.slice(0, max).join(', ')} e altri ${names.length - max}.`;
  }
  return `Compila i campi obbligatori: ${names.join(', ')}.`;
};
